import { Http } from '@/lib/http';
export class DSRCalculationMethodService extends Http {
  constructor() {
    super();
    this.endpoint = 'loan-pro/settings/dsr-calculations/';
  }
  fetchDSRCalculationMethods() {
    return this.httpClient().get(`${this.endpoint}`);
  }
  updateDSRCalculationMethod(payload) {
    return this.httpClient().patch(`${this.endpoint}${payload.id}`, payload);
  }
}